import styled from 'styled-components';
import theme from 'styles/theme';

import ClockFillIcon from 'assets/images/icons/clock-fill.svg?react';
import ExclamationCircleFillIcon from 'assets/images/icons/exclamation-circle-fill.svg?react';
import CheckFillCircleIcon from 'assets/images/icons/check-fill-circle.svg?react';
import XCircleFillIcon from 'assets/images/icons/x-circle-fill.svg?react';

export const ClockFillIconStyled = styled(ClockFillIcon)`
  color: ${theme.colors.hostfullyYellow};
`;

export const ExclamationCircleFillIconStyled = styled(
  ExclamationCircleFillIcon,
)`
  color: ${theme.colors.hostfullyOrange};
`;

export const CheckFillCircleIconStyled = styled(CheckFillCircleIcon)`
  color: ${theme.colors.hostfullyGreen};
`;

export const XCircleFillIconStyled = styled(XCircleFillIcon)`
  color: ${theme.colors.gray600};
`;
